import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  searching: '',
  user: null,
  token: null,
  startEvent: null,
  finalEvent: null
};

const mutations = {
  setUser: function (state, user) {
    state.user = user
  },
  setToken: function (state, token) {
    state.token = token
  },
  setStartEvent: function (state, startEvent) {
    state.startEvent = startEvent
  },
  setFinalEvent: function (state, finalEvent) {
    state.finalEvent = finalEvent
  }
};

export default new Vuex.Store({state, mutations});



// WEBPACK FOOTER //
// ./src/store.js